import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import type {
  SoftphoneAddParticipantPayload,
  SoftphoneCallCreatePayload,
  SoftphoneCallRecord,
  SoftphoneCallUpdatePayload,
  TokenResponse
} from '@/types/softphone';
import ajax from '@/utils/ajax';

export type {
  SoftphoneAddParticipantPayload,
  SoftphoneCallCreatePayload,
  SoftphoneCallRecord,
  SoftphoneCallUpdatePayload,
  TokenResponse
};

const basePath = '/api/twilio';

const SoftphoneCallRepository = () => {
  const { host } = useContext(AppContext);

  return {
    async fetchToken(): Promise<TokenResponse> {
      const response = await ajax.get({ url: `${host}${basePath}/token/` });
      return response.data as TokenResponse;
    },

    async createCall(data: SoftphoneCallCreatePayload): Promise<SoftphoneCallRecord> {
      const response = await ajax.post({ url: `${host}${basePath}/softphone-calls/`, data });
      return response.data as unknown as SoftphoneCallRecord;
    },

    async updateCall(id: string, data: SoftphoneCallUpdatePayload): Promise<void> {
      await ajax.patch<SoftphoneCallUpdatePayload>({
        url: `${host}${basePath}/softphone-calls/${id}/`,
        data
      });
    },

    async addParticipant(
      callId: string,
      data: SoftphoneAddParticipantPayload
    ): Promise<SoftphoneCallRecord> {
      const response = await ajax.post({
        url: `${host}${basePath}/softphone-calls/${callId}/add-participant/`,
        data
      });
      return response.data as unknown as SoftphoneCallRecord;
    },

    async sendHeartbeat(callId: string): Promise<void> {
      await ajax.get({ url: `${host}/api/heartbeat/`, params: { call_id: callId } });
    }
  };
};

export default SoftphoneCallRepository;
